import { contains, set, unset } from "../../js/lib/util";

export default (el) => {
  const closeButton = el.querySelector(".js-close") as HTMLElement;
  const accordionItems = Array.from(el.querySelectorAll(".js-accordion-item"));
  const viewSupplementsLink = el.querySelector(
    ".js-supplement-modal-link"
  ) as HTMLElement;

  closeButton.addEventListener("click", () => {
    unset(document.body, "showing-slide-out");
    unset(el, "active");
  });

  if (viewSupplementsLink) {
    viewSupplementsLink.addEventListener("click", (e) => {
      e.preventDefault();
      const slideOutFocus = el.querySelector(
        `.js-modal[data-modal="supplement-facts"] button, .js-modal[data-modal="supplement-facts"] a, .js-modal[data-modal="supplement-facts"] [role="button"]`
      ) as HTMLElement;
      set(document.body, "showing-modal");
      set(
        el.querySelector(
          `.js-modal[data-modal="supplement-facts"]`
        ) as HTMLElement,
        "active"
      );
      set(slideOut, "active");
      slideOutFocus.focus();
    });
  }

  const reset = () => {
    for (let item of accordionItems) {
      const body = item.querySelector(".js-accordion-item-body") as HTMLElement;
      body.style.maxHeight = "0";
      unset(item, "is-active");
    }
  };

  for (let item of accordionItems) {
    item.addEventListener("click", () => {
      const content = item.querySelector(
        ".js-accordion-item-content"
      ) as HTMLElement;
      const body = item.querySelector(".js-accordion-item-body") as HTMLElement;
      const button = item.querySelector("button") as HTMLButtonElement;
      const wasActive = contains(item, "is-active");

      reset();
      if (wasActive) {
        body.style.maxHeight = "0";
        unset(item, "is-active");
        body.setAttribute("aria-hidden", true);
        button.setAttribute("aria-expanded", false);
      } else {
        body.style.maxHeight = `${content.getBoundingClientRect().height}px`;
        set(item, "is-active");
        body.setAttribute("aria-hidden", false);
        button.setAttribute("aria-expanded", true);
      }
    });
  }
};
